import React, { useState,useRef } from 'react';
import { connect } from 'react-redux';
import { updateStepData } from '../../Store/Actions/Partner';

import { useMediaQuery } from 'react-responsive';

import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Divider } from 'primereact/divider';
import { Panel } from 'primereact/panel';
import { Password } from 'primereact/password';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Tooltip } from 'primereact/tooltip';
import { FileUpload } from 'primereact/fileupload';
import { Toast } from 'primereact/toast';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import UploadFileItem from '../../Components/UploadFileItem';
import * as AppActions from '../../Store/Actions/App';

import {
  maskPhone,
  validateSingleField
} from '../../Components/Utils'

    
const ufsList = [
  { label: 'AC', value: 'AC' },
  { label: 'AL', value: 'AL' },
  { label: 'AP', value: 'AP' },
  { label: 'AM', value: 'AM' },
  { label: 'BA', value: 'BA' },
  { label: 'CE', value: 'CE' },
  { label: 'DF', value: 'DF' },
  { label: 'ES', value: 'ES' },
  { label: 'GO', value: 'GO' },
  { label: 'MA', value: 'MA' },
  { label: 'MT', value: 'MT' },
  { label: 'MS', value: 'MS' },
  { label: 'MG', value: 'MG' },
  { label: 'PA', value: 'PA' },
  { label: 'PB', value: 'PB' },
  { label: 'PR', value: 'PR' },
  { label: 'PE', value: 'PE' },
  { label: 'PI', value: 'PI' },
  { label: 'RJ', value: 'RJ' },
  { label: 'RN', value: 'RN' },
  { label: 'RS', value: 'RS' },
  { label: 'RO', value: 'RO' },
  { label: 'RR', value: 'RR' },
  { label: 'SC', value: 'SC' },
  { label: 'SP', value: 'SP' },
  { label: 'SE', value: 'SE' },
  { label: 'TO', value: 'TO' }
];


const RegisterStep2 = (props) => {

  // Set var from props
  const { 
      stepIndex, 
      stepData, 
      stepDataAll,
      updateStepData,
      setAlert, 
      setAlertTitle, 
      setAlertBody,
      stepValidations,
      servicesList,
      specialitiesList,
      discountsList
  } = props;

   console.log('stepDataAll STEP 2----------->'+JSON.stringify(stepDataAll,null,2));

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  // Set changed vars
  const formDataRef = React.useRef({});
  const toast = React.useRef(null);
  const fileUploadRef = React.useRef(null);
  const fileStoreRef = React.useRef({});

  const [formFields, setFormFields] = React.useState({
    companyMainEmail: stepData?.companyMainEmail || '',
    companyWppPhone: stepData?.companyWppPhone || '',
    companyBusinessType: stepData?.companyBusinessType || '',
    companyDescription: stepData?.companyDescription || '',
    serviceCategories: stepData?.serviceCategories || [],

    servicesOffered: stepData?.servicesOffered || [],
    servicesOfferedFull: stepData?.servicesOfferedFull || [],
    discountsOffered: stepData?.discountsOffered || [],
    discountsOfferedFull: stepData?.discountsOfferedFull || [],

    companyDocuments: stepData?.companyDocuments || [],
    sendDocumentsLater: stepData?.sendDocumentsLater || false,
    technicalResponsibleName: stepData?.technicalResponsibleName || '',
    technicalResponsibleNumber: stepData?.technicalResponsibleNumber || '',
    technicalResponsibleUf: stepData?.technicalResponsibleUf || '',
    
    autoFields: stepData?.autoFields ?? true,
    autoFieldsFill: stepData?.autoFieldsFill ?? true,
    autoFieldsFilled: stepData?.autoFieldsFilled ?? false,
    autoPersonFieldsFilled: stepData?.autoPersonFieldsFilled ?? false,
    documentReady: stepData?.documentReady ?? false,
    personDocumentReady: stepData?.personDocumentReady ?? false,
    validatedContact: stepData?.validatedContact ?? false, // controle se validou email e/ou telefone
    createdUser: stepData?.createdUser ?? false, // controle se criou o usuario
  });  

  // Interface controls Loading Data
  const [loading, setLoading] = React.useState(true); 
  const [saving, setSaving] = React.useState(false); 
  const [loadingData, setLoadingData] = React.useState(false);
  const [loadingPersonData, setPersonLoadingData] = React.useState(false);

  // Estado local para arquivos temporários antes da confirmação
  const [tempFiles, setTempFiles] = useState([]);
  
  // controle area drag and drop
  const [isDragActive, setIsDragActive] = useState(false);

  const documentTypes = [
    { label: 'Contrato Social', value: 'contratoSocial' },
    { label: 'Cartão CNPJ', value: 'cartaoCNPJ' },
    { label: 'CRP do responsável', value: 'crmResponsavel' },
    { label: 'Certificados', value: 'certificado' },
    // Adicione outros tipos conforme necessário
  ]
  
  /* Save on Redux Store changes on fields */
/*const handleFieldChange = (fieldName, value) => {
  setFormFields(prev => {
    const updated = { ...prev, [fieldName]: value };
    formDataRef.current = updated;

    // 🔁 Atualiza documentReady com base nas regras:
    if (fieldName === 'companyDocuments' || fieldName === 'sendDocumentsLater') {
      const currentDocs = fieldName === 'companyDocuments' ? value : updated.companyDocuments;
      const currentSendLater = fieldName === 'sendDocumentsLater' ? value : updated.sendDocumentsLater;

      const hasDocs = Object.values(currentDocs || {}).some(arr => Array.isArray(arr) && arr.length > 0);
      const isReady = currentSendLater ? true : hasDocs;

      updated.documentReady = isReady;
      formDataRef.current.documentReady = isReady;

      // ✅ Salva no Redux também
      updateStepData(stepIndex, { documentReady: isReady });
    }

    return updated;
  });

  formDataRef.current[fieldName] = value;
};*/

const handleFieldChange = (fieldName, value) => {
  setFormFields(prev => {
    const updated = { ...prev, [fieldName]: value };
    formDataRef.current = updated;

    // 🔁 Atualiza documentReady com base nas regras:
    if (fieldName === 'companyDocuments' || fieldName === 'sendDocumentsLater') {
      const currentDocs = fieldName === 'companyDocuments' ? value : updated.companyDocuments;
      const currentSendLater = fieldName === 'sendDocumentsLater' ? value : updated.sendDocumentsLater;

      const hasDocs = Object.values(currentDocs || {}).some(arr => Array.isArray(arr) && arr.length > 0);
      const isReady = currentSendLater ? true : hasDocs;

      updated.documentReady = isReady;
      formDataRef.current.documentReady = isReady;
    }

    // ✅ Sempre atualiza o Redux com o novo estado
    //updateStepData(stepIndex, updated);

    return updated;
  });

  formDataRef.current[fieldName] = value;
};


  
/* Save on Redux Store changes on actions */
  const setActionCompleted = (fieldName, status = true) => {
    updateStepData(stepIndex, { [fieldName]: status });
  };  
  
const handleBusinessTypeChange = (value) => {
  handleFieldChange('companyBusinessType', value);

  if (value === 'oticas') { 
    // Se for ótica, coloca "N/A" no CRM
    handleFieldChange('technicalResponsibleNumber', 'N/A');
    handleFieldChange('technicalResponsibleUf', 'RJ');
    handleFieldChange('serviceCategories',[])

    // ✅ Atualiza Redux para persistir o valor corretamente
    updateStepData(stepIndex, {
      ...formDataRef.current,
      serviceCategories: []
    });

  } else {
    // Se for médicos, limpa o campo para preencher
    handleFieldChange('technicalResponsibleNumber', '');
    handleFieldChange('technicalResponsibleUf', '');

    // ✅ Atualiza Redux para persistir o valor corretamente
    updateStepData(stepIndex, {
      ...formDataRef.current,
      technicalResponsibleNumber: '',
      technicalResponsibleUf: ''
    });

  }
};  

const handleCRMNumberChange = (e) => {
  let value = e.target.value.replace(/\D/g, ''); // só números
  if (value.length > 6) value = value.substring(0,6);

  handleFieldChange('technicalResponsibleNumber', value);
};

const handleCRMUfChange = (e) => {
  const ufSelected = e.value;

  handleFieldChange('technicalResponsibleUf', ufSelected);

  // Agora monta o CRM completo
  const finalCRM = (formFields.technicalResponsibleNumber || '') + '/' + ufSelected;

  // ✅ Atualiza Redux para persistir o valor corretamente
  updateStepData(stepIndex, {
    ...formDataRef.current,
    technicalResponsibleUf: ufSelected
  });
};


  const handleBlur = () => {
    updateStepData(stepIndex, { ...formDataRef.current });
  };

  // Servicos obrigatórios
  React.useEffect(() => {

    const mandatoryServices = (servicesList || [])
      .filter(service => service.required)
      .map(service => service.id);
  
    if (mandatoryServices.length > 0) {
      const currentSelected = formFields.servicesOffered || [];
      const updatedSelected = Array.from(new Set([...currentSelected, ...mandatoryServices]));
  
      const isDifferent =
        updatedSelected.length !== currentSelected.length ||
        !updatedSelected.every(val => currentSelected.includes(val));
  
      if (isDifferent) {
        // Atualiza servicesOfferedFull também
        const selectedServiceData = servicesList
          .filter(service => updatedSelected.includes(service.id))
          .map(service => ({
            label: service.name,
            value: service.id,
            ...service
          }));
  
        setFormFields(prev => {
          const updated = {
            ...prev,
            servicesOffered: updatedSelected,
            servicesOfferedFull: selectedServiceData
          };
          formDataRef.current = updated;
          return updated;
        });
  
        updateStepData(stepIndex, {
          servicesOffered: updatedSelected,
          servicesOfferedFull: selectedServiceData
        });
  
        handleFieldChange('servicesOffered', updatedSelected);
        handleFieldChange('servicesOfferedFull', selectedServiceData);
      }
    }
  }, [servicesList]);
  
// Descontos obrigatórios
  React.useEffect(() => {
    
    const mandatoryDiscounts = (discountsList || [])
      .filter(discount => discount.required)
      .map(discount => discount.id);
  
    if (mandatoryDiscounts.length > 0) {
      const currentSelected = formFields.discountsOffered || [];
      const updatedSelected = Array.from(new Set([...currentSelected, ...mandatoryDiscounts]));
  
      const isDifferent =
        updatedSelected.length !== currentSelected.length ||
        !updatedSelected.every(val => currentSelected.includes(val));
  
      if (isDifferent) {
        // Atualiza discountsOfferedFull também
        const selectedDiscountData = discountsList
          .filter(discount => updatedSelected.includes(discount.id))
          .map(discount => ({
            label: discount.name,
            value: discount.id,
            ...discount
          }));
  
        setFormFields(prev => {
          const updated = {
            ...prev,
            discountsOffered: updatedSelected,
            discountsOfferedFull: selectedDiscountData
          };
          formDataRef.current = updated;
          return updated;
        });
  
        updateStepData(stepIndex, {
          discountsOffered: updatedSelected,
          discountsOfferedFull: selectedDiscountData
        });
  
        handleFieldChange('discountsOffered', updatedSelected);
        handleFieldChange('discountsOfferedFull', selectedDiscountData);
      }
    }
  }, [discountsList]);
    
  return (
    <div style={{ width: '100%'}}>

      <Panel header="Sobre o negócio" style={{marginBottom:"20px",border:"0"}}>
        <Grid container spacing={4} style={{marginTop:"-20px"}}>
          <Grid item xs={12} sm={12}>
          <div className="w100 tAlignL formControl">
              <label htmlFor="companyLegalName">Telefone Whatsapp <span className="requiredField">*</span></label>
              <InputText
                id="companyWppPhone"
                tabIndex={1} 
                autoComplete="new-password"
                disabled={saving}
                className="w100"
                value={formFields.companyWppPhone}
                onChange={(e) => handleFieldChange('companyWppPhone', maskPhone(e.target.value))}
                onBlur={() => {
                  handleBlur();
                  const error = validateSingleField(stepValidations, 'companyWppPhone', formFields.companyWppPhone);
                  if (error) {
                    setAlert(true);
                    setAlertTitle('Telefone Whatsapp digitado é inválido');
                    setAlertBody(error);
                  }
                }}
                placeholder="Informe o telefone Whatsapp"
                tooltip="Digite apenas números"
                tooltipOptions={{ position: 'bottom', event: 'focus' }}
              />
              <small className="fLight">O número de whatsapp do seu negócio será usado para envio dos direcionamentos e marcação de consultas (no caso de clínicas).</small>
            </div>
          </Grid>
          <Grid item xs={12} sm={12}>
            <div className="w100 tAlignL formControl">
            <label htmlFor="companyEmail">Email principal<span className="requiredField">*</span></label>
              <InputText
                id="companyMainEmail"
                tabIndex={2} 
                autoComplete="new-password"
                disabled={saving}
                className="w100"
                value={formFields.companyMainEmail}
                onChange={(e) => handleFieldChange('companyMainEmail', e.target.value)}
                onBlur={() => {
                  handleBlur();
                  const error = validateSingleField(stepValidations, 'companyMainEmail', formFields.companyMainEmail);
                  if (error) {
                    setAlert(true);
                    setAlertTitle('Email digitado é inválido');
                    setAlertBody(error);
                  }
                }}
                placeholder="Digite email principal da empresa"
              />
            </div>
          </Grid>   
          <Grid item xs={12} sm={12}>
            <div className="w100 tAlignL formControl">
              <label htmlFor="companyBusinessType">Tipo de negócio <span className="requiredField">*</span></label>
              <Dropdown
                id="companyBusinessType"
                tabIndex={3} 
                autoComplete="new-password"
                disabled={saving}
                className="w100"
                value={formFields.companyBusinessType}
                options={[
                  { label: 'Médicos e Clínicas', value: 'medicos_clinicas' },
                  { label: 'Óticas', value: 'oticas' }
                ]}
                onChange={(e) => {
                  handleBusinessTypeChange(e.value); // já atualiza o estado e limpa/preenche CRM
                  handleBlur(); // 🔁 salva no Redux imediatamente
                }}                
                onSelect={handleBlur}
                placeholder="Selecione"
                optionLabel="label"
                tooltip="Escolha o tipo de negócio da empresa"
                tooltipOptions={{ position: 'bottom', event: 'focus' }}
              />
            </div>
          </Grid>

        {/* Descrição do Negócio */}
        <Grid item xs={12} sm={12}>
          <div className="w100 tAlignL formControl">
            <label htmlFor="companyDescription">Descrição do negócio</label>
            <InputTextarea
              id="companyDescription"
              tabIndex={4} 
              autoResize
              rows={5}
              className="w100"
              disabled={saving}
              value={formFields.companyDescription}
              onChange={(e) => handleFieldChange('companyDescription', e.target.value)}
              onBlur={handleBlur}
              placeholder="Informe um resumo do seu negócio"
            />
            <small className="fLight">Informe um resumo do seu negócio, incluindo o que sua empresa faz; qual o seu público-alvo e os diferenciais do seu negócio.</small>
          </div>
        </Grid>   

        {/* Subespecialidades */}
        {formFields.companyBusinessType == "medicos_clinicas" &&
          <Grid item xs={12} sm={12}>
            <div className="w100 tAlignL formControlAlt">
              <label htmlFor="serviceCategories">Selecione as suas subespecialidades na oftalmologia <span className="requiredField">*</span></label>
              <MultiSelect
                id="serviceCategories"
                tabIndex={5} 
                value={formFields.serviceCategories || []}
                options={specialitiesList}
                onChange={(e) => handleFieldChange('serviceCategories', e.value)}
                onHide={handleBlur}                             
                optionLabel="name"
                optionValue="id"
                placeholder="Selecione ao menos uma subespecialidade"
                className="w100 customChipWrapper"
                display="comma"
                selectedItemTemplate={(value) => {
                  const category = specialitiesList.find(s => s.id === value);
                  const label = category?.name || null;
                  if (!label) return null;
                  return (
                    <div className="customChip">
                    <span className="content">{label}</span>
                  </div>
                  );
                }}                            
              />
            </div>
          </Grid>
        }

        {/* Serviços oferecidos */}
        {formFields.companyBusinessType == "medicos_clinicas" &&
        <Grid item xs={12} sm={12}>
          <div className="w100 tAlignL formControlAlt">
            <label htmlFor="servicesOffered">Selecione os serviços oferecidos <span className="requiredField">*</span></label>
            <MultiSelect
              id="servicesOffered"
              tabIndex={6} 
              value={formFields.servicesOffered || []}
              options={servicesList?.map(s => ({ label: s.name, value: s.id }))}
              onChange={(e) => {
                const selectedValues = e.value || [];
                const mandatoryServices = servicesList
                  .filter(service => service.category?.type === 'service' && service.required)
                  .map(service => service.id);
                            
                const finalSelectedValues = Array.from(new Set([...selectedValues, ...mandatoryServices]));
                
                const selectedServiceData = servicesList.filter(service =>
                  selectedValues.includes(service.id)
                ).map(service => ({
                  label: service.name,
                  value: service.id,
                  ...service
                }));
              
                handleFieldChange('servicesOffered', finalSelectedValues);
                handleFieldChange('servicesOfferedFull', selectedServiceData);

              }}
              onHide={handleBlur}                                                                                       
              optionLabel="label"
              optionValue="value"
              selectedItemTemplate={(value) => {
                const service = servicesList.find(s => s.id === value);
                const label = service?.name || value;
                const isRequired = service?.required;
              
                return (
                  <div className={`customChip ${isRequired ? 'requiredChip' : ''}`}>
                    <span className="content">{label}</span>
                    {isRequired ? (<span className="badge">Obrigatório</span>) : null}
                  </div>
                );
              }}
              placeholder="Selecione um ou mais serviços"
              className="w100 customChipWrapper"
              display="comma"
            />
          </div>
        </Grid>
        }

        {/* Serviços oferecidos */}
        {formFields.companyBusinessType == "oticas" &&
        <Grid item xs={12} sm={12}>
          <div className="w100 tAlignL formControlAlt">
            <label htmlFor="discountsOffered">Selecione os descontos oferecidos <span className="requiredField">*</span></label>
            <MultiSelect
              id="discountOffered"
              tabIndex={6} 
              value={formFields.discountsOffered || []}
              options={discountsList?.map(s => ({ label: s.name, value: s.id }))}
              onChange={(e) => {
                const selectedValues = e.value || [];
                const mandatoryDiscounts = discountsList
                  .filter(discount => discount.category?.type === 'discount' && discount.required)
                  .map(discount => discount.id);
                            
                const finalSelectedValues = Array.from(new Set([...selectedValues, ...mandatoryDiscounts]));
                
                const selectedDiscountData = discountsList.filter(discount =>
                  selectedValues.includes(discount.id)
                ).map(discount => ({
                  label: discount.name,
                  value: discount.id,
                  ...discount
                }));
              
                handleFieldChange('discountsOffered', finalSelectedValues);
                handleFieldChange('discountsOfferedFull', selectedDiscountData);

              }}
              onHide={handleBlur}                                                                                       
              optionLabel="label"
              optionValue="value"
              selectedItemTemplate={(value) => {
                const discount = discountsList.find(s => s.id === value);
                const label = discount?.name || value;
                const isRequired = discount?.required;
              
                return (
                  <div className={`customChip ${isRequired ? 'requiredChip' : ''}`}>
                    <span className="content">{label}</span>
                    {isRequired ? (<span className="badge">Obrigatório</span>) : null}
                  </div>
                );
              }}
              placeholder="Selecione um ou mais serviços"
              className="w100 customChipWrapper"
              display="comma"
            />
          </div>
        </Grid>
        }

        </Grid>
      </Panel>    

      {/* Upload de documentos e certificados */}
      <Panel className="panelFileUpload" header={(<>
              {/* Quero enviar depois */}
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} className="w100 tAlignL">
                  Upload de certificados e documentos <span className="requiredField">*</span>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div className={isMobile ?  "w100 flex-row justify-start align-items-center formControl" : "w100 flex-row justify-end align-items-center formControl"}>
                    <Checkbox
                      inputId="sendDocumentsLater"
                      tabIndex={8} 
                      checked={formFields.sendDocumentsLater || false}
                      onChange={(e) => {
                        const checked = e.checked;
                    
                        const shouldMarkDocumentReady = checked || Object.keys(formFields.companyDocuments || {}).length > 0;
                    
                        const updated = {
                          ...formFields,
                          sendDocumentsLater: checked,
                          documentReady: shouldMarkDocumentReady
                        };
                    
                        setFormFields(updated);
                        formDataRef.current = updated;
                        updateStepData(stepIndex, updated);
                      }}
                    />
                    <label htmlFor="sendDocumentsLater" style={{ marginLeft: "8px", marginBottom: 0 }}>
                      Quero enviar depois
                    </label>
                  </div>
                </Grid>
              </Grid>
        </>)} style={{ marginBottom: "20px" }}>
        <Grid container spacing={3} style={{ marginTop: "-20px" }}>
          <Grid item xs={12} sm={12}>

            {formFields.sendDocumentsLater && (
              <div className="warningText" style={{fontWeight:"normal"}}>
                <i className="pi pi-exclamation-triangle" style={{ marginRight: '0.5rem', color: '#fbc02d' }}></i>
                Você optou por enviar os documentos depois. Isso pode atrasar a análise do seu cadastro e mesmo com o cadastro aprovado e recebendo direcionamentos a ausência dos documentos poderá colocar o cadastro em análise até envio.                
              </div>
            )}

          {!formFields.sendDocumentsLater &&
            <div className="w100 tAlignL formControl">
              {/* Dropdown de seleção de tipo */}
              <div>
                <Dropdown
                  id="documentType"
                  tabIndex={7} 
                  value={formFields.selectedDocumentType || null}
                  options={documentTypes}
                  onChange={(e) => handleFieldChange('selectedDocumentType', e.value)}
                  placeholder="Selecione o tipo de documento"
                  className="w100"
                />
              </div>

              {/* Upload de arquivos */}
              <div style={{ marginTop: "1rem" }}>
              <Toast ref={toast} position="bottom-center"  />
              <FileUpload
                ref={fileUploadRef}
                className={!formFields.selectedDocumentType ? 'hide-buttons' : ''} 
                name="companyDocuments"
                url={null}
                accept="application/pdf,image/png,image/jpeg"
                maxFileSize={5242880} // 5MB
                multiple
                customUpload
                disabled={!formFields.selectedDocumentType}
                chooseLabel="Selecionar arquivos"
                uploadLabel="Confirmar envio"
                cancelLabel="Cancelar envio"
                mode="advanced"
                onDragOver={(e) => {
                  if (!formFields.selectedDocumentType) {
                    e.preventDefault();
                    e.stopPropagation();
                    toast.current?.show({
                      severity: 'warn',
                      summary: 'Atenção',
                      detail: 'Selecione o tipo de documento antes de enviar arquivos.',
                      life: 6000
                    });
                    return false;
                  }
                  setIsDragActive(true);
                }}
                onDragLeave={() => setIsDragActive(false)}
                onDrop={() => setIsDragActive(false)}
                beforeDrop={(event) => {
                  if (!formFields.selectedDocumentType) {
                    event.preventDefault();
                    event.stopPropagation();
                    return false;
                  }
                  return true;
                }}
                uploadHandler={() => {
                  if (!tempFiles || tempFiles.length === 0) {
                    toast.current?.show({
                      severity: 'warn',
                      summary: 'Atenção',
                      detail: 'Você precisa selecionar pelo menos um arquivo antes de confirmar o envio.',
                      life: 5000
                    });
                    return;
                  }
                
                  const previousFiles = formFields.companyDocuments || {};
                  const currentType = formFields.selectedDocumentType;
                
                  const updatedFilesForType = previousFiles[currentType]
                    ? [...previousFiles[currentType], ...tempFiles]
                    : [...tempFiles];

                  // Grava os arquivos reais em memória (não Redux)
                  fileStoreRef.current[currentType] = [
                    ...(fileStoreRef.current[currentType] || []),
                    ...tempFiles
                  ];                    
                
                  const updatedDocuments = {
                    ...previousFiles,
                    [currentType]: updatedFilesForType
                  };

                  // ✅ Atualiza o estado local e a referência com documentReady
                  setFormFields((prev) => {
                    const updated = {
                      ...prev,
                      companyDocuments: updatedDocuments,
                      documentReady: prev.sendDocumentsLater === true || Object.keys(updatedDocuments).length > 0
                    };
                    formDataRef.current = updated;
                    return updated;
                  });
                
                  // ✅ Atualiza o Redux
                  updateStepData(stepIndex, { ...formDataRef.current });
                
                  toast.current?.show({
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: 'Documentos adicionados com sucesso!',
                    life: 6000
                  });
                
                  // Limpa o estado e o componente de upload
                  handleFieldChange('selectedDocumentType', null);
                  setTempFiles([]);
                
                  if (fileUploadRef.current) {
                    fileUploadRef.current.clear();
                  }
                }}                
                onClear={() => {
                  handleFieldChange('selectedDocumentType', null);
                  setTempFiles([]);
                  if (fileUploadRef.current) {
                    fileUploadRef.current.clear();
                  }
                }}
                onSelect={(e) => {
                  const filesUploaded = e.files || [];
                  // Lista de tipos permitidos
                  const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
                
                  // Filtra os arquivos permitidos
                  const validFiles = filesUploaded.filter(file => allowedTypes.includes(file.type));
                
                  if (validFiles.length !== filesUploaded.length) {
                    // Algum arquivo inválido foi tentado
                    toast.current?.show({
                      severity: 'error',
                      summary: 'Arquivo inválido',
                      detail: 'Só é permitido enviar arquivos PDF, JPG ou PNG.',
                      life: 6000
                    });
                  }
                
                  setTempFiles(validFiles);
                }}
                emptyTemplate={!formFields.selectedDocumentType ? (<p className="m-0">Selecione o tipo de documento para habilitar o envio de arquivos.</p>) : (<p className="m-0">Arraste e solte os arquivos nessa região ou clique em "Selecionar arquivos" para selecionar os arquivos.</p>)}
                itemTemplate={(file, props) => (
                  <UploadFileItem file={file} index={props.index} onRemove={props.onRemove} />
                )}
              />
                <small>Formatos aceitos: PDF, PNG, JPG. Tamanho máximo: 5MB por arquivo.</small>
              </div>
            </div>
            }
          </Grid>

          {/* Documentos confirmados agrupados */}
          {formFields.companyDocuments && Object.keys(formFields.companyDocuments).length > 0 && (
            <Grid item xs={12} sm={12}>
              <div className="w100 tAlignL formControl">
                <label>Documentos selecionados:</label>

                {Object.keys(formFields.companyDocuments).map((docType, idx) => (
                  <div key={idx} style={{ marginTop: "1rem" }}>
                    <h4 style={{ marginBottom: "0.5rem", fontSize: "1rem" }}>
                      {docType} ({formFields.companyDocuments[docType]?.length || 0})
                    </h4>
                    <ul style={{ listStyleType: "none", paddingLeft: 0, marginBottom: "1rem" }}>
                      {formFields.companyDocuments[docType].map((file, index) => (
                        <li key={index} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "#f9f9f9", padding: "0.5rem 1rem", borderRadius: "8px", marginBottom: "0.3rem" }}>
                          <span style={{ fontSize: "0.9rem", wordBreak: "break-word" }}>{file.name}</span>
                          <Button
                            label="Remover"
                            icon="pi pi-times"
                            className="p-button-danger p-button-text"
                            onClick={() => {
                              const updatedFiles = formFields.companyDocuments[docType].filter((_, idx) => idx !== index);
                              const updatedDocuments = { ...formFields.companyDocuments };
                            
                              if (updatedFiles.length === 0) {
                                delete updatedDocuments[docType];
                              } else {
                                updatedDocuments[docType] = updatedFiles;
                              }
                            
                              const shouldMarkDocumentReady = formFields.sendDocumentsLater === true || Object.keys(updatedDocuments).length > 0;
                            
                              // Atualiza o estado local e a referência
                              setFormFields((prev) => {
                                const updated = {
                                  ...prev,
                                  companyDocuments: updatedDocuments,
                                  documentReady: shouldMarkDocumentReady
                                };
                                formDataRef.current = updated;
                                return updated;
                              });
                            
                              // Atualiza Redux
                              updateStepData(stepIndex, { ...formDataRef.current });
                            }}
                            style={{ padding: "0.2rem 0.6rem", fontSize: "0.8rem" }}
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}

              </div>
            </Grid>
          )}

          <Grid item xs={12} sm={12}>
            <div className="w100 tAlignL documentsGuideContainer">

            Documentos necessários para aprovação do cadastro:
            <ul>
              <li>Contrato Social</li>
              <li>Cartão CNPJ</li>
              
              {formFields.companyBusinessType == "medicos_clinicas" &&
              <>
                <li>CRP do responsável</li>
                <li>Certificados de conclusão de curso, especialização, pós-graduação, mestrado e etc (OPCIONAL)</li>
              </>
              }
            </ul>

            </div>
          </Grid>          

        </Grid>
      </Panel>    


      <Panel header="Sobre o responsável técnico" style={{marginBottom:"20px"}}>
        <Grid container spacing={4} style={{marginTop:"-20px"}}>
          <Grid item xs={12} sm={12} style={{display:"flex",flexDirection:"row",justifyContent:"flex-start",alignItems:"center"}}>
            <div className="w100 tAlignL formControl">
            <label htmlFor="technicalResponsibleName">Nome do responsável técnico <span className="requiredField">*</span></label>
              <InputText
                id="personName"
                tabIndex={9} 
                autoComplete="new-password"
                disabled={saving}
                value={formFields.technicalResponsibleName}
                onChange={(e) => handleFieldChange('technicalResponsibleName', e.target.value)}
                onBlur={handleBlur}
                style={{ width: "100%" }}
                placeholder="Informe o responsável técnico da empresa"          
              />
              
            </div>
          </Grid>
          {formFields.companyBusinessType === 'medicos_clinicas' && (<>
          <Grid item xs={8} sm={8} style={{display:"flex",flexDirection:"row",justifyContent:"flex-start",alignItems:"center"}}>
            <div className="w100 tAlignL formControl">
            <label htmlFor="technicalResponsibleName">CRM do responsável técnico <span className="requiredField">*</span></label>
            <InputText
              id="technicalResponsibleNumber"
              tabIndex={10} 
              autoComplete="new-password"
              disabled={saving}
              value={formFields.technicalResponsibleNumber || ''}
              onChange={(e) => handleCRMNumberChange(e)}
              onBlur={handleBlur}
              style={{ width: "100%" }}
              placeholder="Digite os 6 números do CRM"
              maxLength={6}
            />              
            </div>
          </Grid>
          <Grid item xs={4} sm={4} style={{display:"flex",flexDirection:"row",justifyContent:"flex-start",alignItems:"center"}}>
            <div className="w100 tAlignL formControl">
            <label htmlFor="technicalResponsibleName">Estado<span className="requiredField">*</span></label>
            <Dropdown
              id="technicalResponsibleUf"
              tabIndex={11} 
              disabled={saving || !formFields.technicalResponsibleNumber || formFields.technicalResponsibleNumber.length < 6}
              value={formFields.technicalResponsibleUf || ''}
              options={ufsList}
              onChange={(e) => {
                handleCRMUfChange(e); // já atualiza o estado e limpa/preenche CRM
                handleBlur(); // 🔁 salva no Redux imediatamente
              }}                            
              onSelect={handleBlur}
              placeholder="UF do CRM"
              style={{ width: "100%" }}
            />
            </div>
          </Grid>
          </>)}
        </Grid>
      </Panel>

    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  stepData: state.partnerReducer.stepData[ownProps.stepIndex],
  stepDataAll: state.partnerReducer.stepData,
  servicesList: state.partnerReducer.servicesList,
  discountsList: state.partnerReducer.discountsList,
  specialitiesList: state.partnerReducer.specialitiesList,
});

const mapDispatchToProps = {
  updateStepData,
  ...AppActions // inclui retrieveCompanyServices e retrieveCompanySpecialities
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterStep2);
